var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { attrs: { id: "components-form-demo-advanced-search" } },
        [
          _c(
            "a-form",
            {
              staticClass: "ant-advanced-search-form",
              attrs: { form: _vm.form },
              on: { submit: _vm.handleSearch },
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 18 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "宣传册名称" } },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["brochureName"],
                                expression: "[`brochureName`]",
                              },
                            ],
                            staticStyle: { width: "250px" },
                            attrs: { placeholder: "请输入标题名称搜索" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    {
                      style: { textAlign: "right", lineHeight: "42px" },
                      attrs: { span: 6 },
                    },
                    [
                      _c(
                        "a-button",
                        { attrs: { type: "primary", "html-type": "submit" } },
                        [_vm._v(" 搜索 ")]
                      ),
                      _c(
                        "a-button",
                        {
                          style: { marginLeft: "8px" },
                          on: { click: _vm.handleReset },
                        },
                        [_vm._v(" 重置 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fix" },
        [
          _c(
            "div",
            { staticClass: "left_tree l" },
            [
              _c(
                "a-spin",
                {
                  staticStyle: { height: "100%" },
                  attrs: { spinning: _vm.treeSpin },
                },
                [
                  _c("div", { staticClass: "fix" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn l",
                        staticStyle: { margin: "0 3px 10px 0" },
                        on: { click: _vm.add },
                      },
                      [_vm._v("新增")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn l",
                        staticStyle: { margin: "0 3px 10px 0" },
                        on: { click: _vm.edit },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn l",
                        staticStyle: { margin: "0 3px 10px 0" },
                        on: { click: _vm.del },
                      },
                      [_vm._v("删除")]
                    ),
                  ]),
                  _c(
                    "a-tree",
                    {
                      attrs: {
                        "show-icon": true,
                        checkStrictly: true,
                        defaultExpandAll: false,
                        defaultExpandParent: true,
                        expandedKeys: _vm.defaultExpandedKeys,
                        "tree-data": _vm.deptList,
                        selectedKeys: _vm.selectedKeys,
                        replaceFields: {
                          children: "children",
                          title: "codeName",
                          key: "codeId",
                          value: "codeId",
                        },
                      },
                      on: {
                        "update:expandedKeys": function ($event) {
                          _vm.defaultExpandedKeys = $event
                        },
                        "update:expanded-keys": function ($event) {
                          _vm.defaultExpandedKeys = $event
                        },
                        select: _vm.onSelect,
                      },
                    },
                    [
                      _c("a-icon", {
                        staticStyle: { color: "#2fcfeb" },
                        attrs: { slot: "dealer", type: "team" },
                        slot: "dealer",
                      }),
                      _c("a-icon", {
                        staticStyle: { color: "#52c41a" },
                        attrs: { slot: "region", type: "cluster" },
                        slot: "region",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("a-list", {
            staticStyle: { width: "75%", float: "left" },
            attrs: {
              grid: { gutter: 35, xs: 2, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 },
              "data-source": _vm.marketListData,
            },
            scopedSlots: _vm._u([
              {
                key: "renderItem",
                fn: function (item, index) {
                  return _c("a-list-item", {}, [
                    item.isFirst
                      ? _c(
                          "div",
                          {
                            staticClass: "item_box new pr",
                            on: { click: _vm.createNew },
                          },
                          [
                            _c(
                              "p",
                              { staticClass: "new_icon" },
                              [
                                _c("a-icon", {
                                  staticClass: "add_icon",
                                  attrs: {
                                    type: "plus-circle",
                                    theme: "filled",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("p", { staticClass: "new_tips tr" }, [
                              _vm._v("创建产品宣传册"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    index
                      ? _c("div", { staticClass: "item_box pr" }, [
                          _c(
                            "div",
                            {
                              staticClass: "img_box pr",
                              on: {
                                click: function ($event) {
                                  return _vm.showDetail(item.brochureId)
                                },
                              },
                            },
                            [
                              item.brochureType == "image" && item.brochureUrl
                                ? _c("img", {
                                    attrs: {
                                      src:
                                        _vm.api.temp.FILE_PATH +
                                        item.brochureUrl.split(",")[0],
                                    },
                                  })
                                : (item.brochureType == "video" ||
                                    item.brochureType == "file") &&
                                  item.coverImg
                                ? _c("img", {
                                    attrs: {
                                      src:
                                        _vm.api.temp.FILE_PATH + item.coverImg,
                                    },
                                  })
                                : item.brochureType == "file" && !item.coverImg
                                ? _c("img", {
                                    attrs: {
                                      src: require("@/assets/img/file_img.png"),
                                    },
                                  })
                                : _c("img", {
                                    attrs: {
                                      src: require("@/assets/img/video.png"),
                                    },
                                  }),
                              _c("div", { staticClass: "pop_btns pa" }, [
                                _c("div", { staticClass: "top_btns" }, [
                                  _c("span"),
                                  _c(
                                    "p",
                                    { staticClass: "icons " },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "icon" },
                                        [
                                          _c("a-icon", {
                                            attrs: { type: "edit" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.showDetail(
                                                  item.brochureId
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-popconfirm",
                                        {
                                          attrs: {
                                            title: "确定删除吗？",
                                            "ok-text": "确定",
                                            "cancel-text": "取消",
                                          },
                                          on: {
                                            confirm: function ($event) {
                                              return _vm.deleteItem(
                                                item.brochureId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "icon",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return function (e) {
                                                    return e.preventDefault()
                                                  }.apply(null, arguments)
                                                },
                                              },
                                            },
                                            [
                                              _c("a-icon", {
                                                attrs: { type: "delete" },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      item.brochureUrl
                                        ? _c(
                                            "span",
                                            { staticClass: "icon" },
                                            [
                                              _c("a-icon", {
                                                attrs: { type: "download" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.downLoad(
                                                      item.brochureUrl,
                                                      "产品宣传册"
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("div", { staticClass: "bottom_btns" }, [
                                  _c("span", [
                                    _vm._v(
                                      "创建人：" + _vm._s(item.createUserName)
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]
                          ),
                          _c("div", { staticClass: "title_box" }, [
                            _c("p", { staticClass: "title el" }, [
                              _vm._v(_vm._s(item.brochureName)),
                            ]),
                            _c("div"),
                          ]),
                        ])
                      : _vm._e(),
                  ])
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.totalPage > 0
        ? _c(
            "div",
            { staticClass: "pagination", staticStyle: { float: "right" } },
            [
              _c("a-pagination", {
                attrs: {
                  current: _vm.currPage,
                  total: _vm.totalCount,
                  pageSize: _vm.limit,
                  "show-less-items": "",
                },
                on: { change: _vm.handleChangePage },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "a-modal",
        {
          attrs: {
            title: "产品宣传册详情",
            centered: "",
            closable: true,
            footer: null,
            maskClosable: false,
            visible: _vm.editModalVisible,
            width: 1200,
          },
          on: {
            cancel: function ($event) {
              return _vm.closeEdit(false)
            },
          },
        },
        [
          _vm.editModalVisible
            ? _c("detailForm", {
                ref: "detailForm",
                attrs: { rowId: _vm.editRowId },
                on: {
                  cancelled: function ($event) {
                    return _vm.closeEdit(false)
                  },
                  saved: function ($event) {
                    return _vm.closeEdit(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "产品宣传册分组",
            closable: true,
            footer: null,
            maskClosable: false,
            visible: _vm.editGrouping,
            width: 600,
          },
          on: {
            cancel: function ($event) {
              return _vm.closeGrouping()
            },
          },
        },
        [
          _vm.editGrouping
            ? _c("ProductBrochureKind", {
                ref: "editGrouping",
                attrs: { rowId: _vm.editGroupingId, parentId: _vm.parentId },
                on: {
                  cancelled: function ($event) {
                    return _vm.closeGrouping()
                  },
                  saved: function ($event) {
                    return _vm.closeGrouping(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("loading"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }